import { init } from '@actengage/telemetry-browser';
import { trackInertiaUser } from '@actengage/telemetry-browser/inertia';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { ActivityIndicator, Spinner } from '@vue-interface/activity-indicator';
import { TooltipPlugin } from '@vue-interface/tooltip';
import { createApp, h, type DefineComponent } from 'vue';
import Toast, { POSITION } from 'vue-toastification';
import type { ToastOptionsAndRequiredContent } from 'vue-toastification/dist/types/types';
import Layout from './Layouts/Layout.vue';
import { useRoutes, type RawRoute } from './composables/routes';

void init();
trackInertiaUser(router);

createInertiaApp({
    progress: {
        delay: 500,
        includeCSS: true,
        showSpinner: false,
    },
    resolve: name => {
        const pages = import.meta.glob<DefineComponent>('./Pages/**/*.vue');
        const resolver = pages[`./Pages/${name}.vue`];

        if(!resolver) {
            throw new Error(`Page not found: ./Pages/${name}.vue`);
        }

        return resolver().then(page => {
            page.default.layout = page.default.layout || Layout;

            return page;
        });
    },
    setup({ el, App, props, plugin }) {
        useRoutes(props.initialPage.props?.routes as RawRoute[] ?? []);

        // This prevents users from being unable to scroll after a modal triggers a redirect.
        router.on('navigate', () => {
            const el = document.querySelector('body');
            if(el) {
                el.style.overflow = '';
            }
        });

        createApp({
            render: () => h(App, props)
        })
            .use(plugin)
            .use(Toast, {
                position: POSITION.BOTTOM_RIGHT,
                showCloseButtonOnHover: true,
                filterBeforeCreate: (toast: ToastOptionsAndRequiredContent, toasts: ToastOptionsAndRequiredContent[]) => {
                    if(toasts.filter((t: ToastOptionsAndRequiredContent) => t.content === toast.content).length !== 0) {
                        return false;
                    }
                    return toast;
                }
            })
            .component('ActivityIndicator', ActivityIndicator)
            .component('Spinner', Spinner)
            .use(TooltipPlugin)
            .mount(el);
    },
});
